// // apiCache.js
// const CACHE = new Map();
// const IN_FLIGHT = new Map();

// const now = () => Date.now();

// export function buildCacheKey({ end_point, apiUrl, token, method, body }) {
//   const bodyString = body ? JSON.stringify(body) : "no-body";
//   return `${end_point}:${apiUrl}:${method}:${token || "public"}:${bodyString}`;
// }

// export function getCache(key) {
//   return CACHE.get(key);
// }

// export function setCache(key, entry) {
//   CACHE.set(key, entry);
// }

// export function deleteCache(key) {
//   CACHE.delete(key);
// }

// export function clearAllCache() {
//   CACHE.clear();
// }

// export function isFresh(entry) {
//   return entry && now() - entry.timestamp < entry.ttl;
// }

// export function getInFlight(key) {
//   return IN_FLIGHT.get(key);
// }

// export function setInFlight(key, promise) {
//   IN_FLIGHT.set(key, promise);
// }

// export function clearInFlight(key) {
//   IN_FLIGHT.delete(key);
// }

// export function invalidateByEndpoint(end_point) {
//   for (const key of CACHE.keys()) {
//     if (key.startsWith(`${end_point}:`)) {
//       CACHE.delete(key);
//     }
//   }
// }

// apiCache.js
const CACHE = new Map();
const IN_FLIGHT = new Map();

const now = () => Date.now();

export function buildCacheKey({ end_point, apiUrl, token, method, body }) {
  const bodyString = body ? JSON.stringify(body) : "no-body";
  return `${end_point}:${apiUrl}:${method}:${token || "public"}:${bodyString}`;
}

export function getCache(key) {
  return CACHE.get(key);
}

export function setCache(key, entry) {
  // If cache already has the key, just update it
  if (CACHE.has(key)) {
    CACHE.set(key, entry);
    return;
  }

  // If cache size is at limit, evict the oldest entry
  if (CACHE.size >= 50) {
    const oldestKey = CACHE.keys().next().value; // first inserted key
    CACHE.delete(oldestKey);
  }

  // Insert new entry
  CACHE.set(key, entry);
}

export function deleteCache(key) {
  CACHE.delete(key);
}

export function clearAllCache() {
  CACHE.clear();
}

export function isFresh(entry) {
  return entry && now() - entry.timestamp < entry.ttl;
}

export function getInFlight(key) {
  return IN_FLIGHT.get(key);
}

export function setInFlight(key, promise) {
  IN_FLIGHT.set(key, promise);
}

export function clearInFlight(key) {
  IN_FLIGHT.delete(key);
}

export function invalidateByEndpoint(end_point) {
  for (const key of CACHE.keys()) {
    if (key.startsWith(`${end_point}:`)) {
      CACHE.delete(key);
    }
  }
}
